<template>
  <div class="login-page">
    <layout>
      <v-layout>
        <v-dialog
          style="z-index: 10;"
          width="550px"
          v-model="askCode"
          persistent
          max-width="800"
        >
          <two-factor-authentication-login ref="loginDialog" @on-close="closeCodeModal" />
        </v-dialog>
        <v-dialog
          style="z-index: 10;"
          width="1200px"
          v-model="askFor2fa"
          persistent
          max-width="800"
        >
          <two-factor-authentication-setup @on-close="close2FaModal" />
        </v-dialog>
        <div class="mx-auto" style="width: 370px; margin-top: 20%;">
          <a href="https://www.facilitapay.com" target="_blank" rel="noopener noreferrer">
            <img style="cursor: pointer; margin-bottom:25px" :src="logoPath()" />
          </a>
          <div class="flex mx-auto" style="margin-bottom:25px">
            <span style="align-items: center; justify-content: center; display:inline-flex; margin-bottom:15px">
              <span class="mr-2" :class="{ isActive: !toggleEnglish }" style="font-size: 16px !important;">Português</span>
              <v-switch
                class="lang-toggle"
                v-model="toggleEnglish"
                @change="changeLanguage"
                color="secondary-button-background-color"
                hide-details
                inset
              />
              <span class="ml-2" :class="{ isActive: toggleEnglish }" style="font-size: 16px !important;">English</span>
            </span>
            <h3 class="standard-text">{{i18n('Acesse a plataforma da FacilitaPay')}}</h3>
          </div>
          <v-form v-model="form_valid" ref="form">
            <v-flex>
              <v-text-field
                :key="emailKey"
                outline
                color="secondary-button-background-color"
                v-model="email"
                background-color="input-color"
                label="E-mail"
                :rules="requiredValidation"
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                outline
                v-model="password"
                :key="passwordKey"
                :type="showPassword ? 'text' : 'password'"
                color="secondary-button-background-color"
                background-color="input-color"
                :label="i18n('Senha')"
                :rules="requiredValidation"
                :errorMessages="passwordErrorMessages"
                @keyup="passwordFieldChanged()"
                @keyup.enter="signIn()">
                <template slot="append">
                  <v-icon @click="showPassword = !showPassword" style="cursor: pointer" color="black">
                    {{ showPassword ? 'visibility' : 'visibility_off' }}
                  </v-icon>
                </template>
              </v-text-field>
            </v-flex>
            <div style="display:flex; justify-content: space-between;">
              <v-checkbox
                v-model="rememberMe"
                :label="`${i18n('Lembrar-me')}`"
              />
              <a href="#" class="grey-text" style="margin-top: 16px" @click="resetPassword">
                {{ i18n('Esqueci minha senha') }}
              </a>
            </div>
            <v-btn class="sign-btn" block large @click="signIn()">
              <div style="display:inline-flex; flex:1; justify-content: center;">
                <h3 bold>{{ i18n('Entrar') }}</h3>
              </div>
              <v-icon medium style="align-items: end;">arrow_forward</v-icon>
            </v-btn>
          </v-form>
        </div>
      </v-layout>
    </layout>
  </div>
</template>

<script>
import LoginLayout from "./layouts/LoginLayout"
import TwoFactorAuthenticationSetup from "./TwoFactorAuthenticationSetup"
import TwoFactorAuthenticationLogin from "./TwoFactorAuthenticationLogin"
import translateOldPermissions from "./shared/translateOldPermissions"

export default {
  name: "Login",
  components: { layout: LoginLayout, TwoFactorAuthenticationSetup, TwoFactorAuthenticationLogin },
  data: () => {
    return {
      email: "",
      emailKey: 0,
      askCode: false,
      askFor2fa: false,
      rememberMe: false,
      password: "",
      passwordKey: 0,
      form_valid: false,
      showPassword: false,
      passwordErrorMessages: [],
      toggleEnglish: true,
    };
  },
  computed: {
    lang(){
      return this.$cookies.get('lang') || 'en'
    },
    requiredValidation() {
      const rules = [];
      const required_rule = (v) => (v || "").length > 0 || this.i18n('Obrigatório');
      rules.push(required_rule);
      return rules;
    }
  },
  methods: {
    closeCodeModal(){
      this.askCode = false
    },
    close2FaModal(){
      this.askFor2fa = false
    },
    i18n(str) {
      return this.$root.l(str)
    },
    logoPath() {
      if (this.$root.getEnvironment() === 'prod') return 'static/logo.svg'
      return 'static/logo-dev.svg'
    },
    changeLanguage(){
      const newLang = this.toggleEnglish ? 'en' : 'pt'
      this.$cookies.set("lang", newLang, new Date(new Date().getTime() + 60 * 12 * 60000));
      this.emailKey += 1;
      this.passwordKey += 1;
      this.passwordErrorMessages = [];
      this.$forceUpdate()
    },
    passwordFieldChanged(e) {
      this.passwordErrorMessages = [];
    },
    resetPassword(e) {
      e.preventDefault();
      e.stopPropagation();
      this.$router.push("/reset_password");
    },
    signIn() {
      this.passwordErrorMessages = [];

      this.$refs.form.validate();
      if (!this.form_valid) return;

      // create user with email or returns error if already exists
      // send email with confirmation code
      const payload = {
        user: {
          username: this.email,
          password: this.password,
        },
      }

      let successCallback = (response) => {
        if (response.body.jwt) {
          let expire_at = new Date(new Date().getTime() + 60 * 12 * 60000) // 12 hours
          this.$cookies.set("api_token", response.body.jwt, expire_at)
          this.$cookies.set("email", response.body.username, expire_at)
          this.$cookies.set("name", response.body.name, expire_at)
          this.rememberMe && this.$cookies.set("last_email", this.email)
          || this.$cookies.remove("last_email")
          if (response.body.admin) {
            this.$root.lang = "pt"
            this.$cookies.set("lang", "pt", expire_at)
            this.$cookies.set("admin", response.body.admin, expire_at)
          } else {
            this.$cookies.remove("admin")
          }
          this.loadMe()
        } else {
          console.log("successCallback", response)
        }
      }

      let errorCallback = (response) => {
        this.password = "";
        if (response.status === 401) {
          this.passwordErrorMessages = this.i18n('Email e/ou senha Incorretos')
        } else {
          this.passwordErrorMessages = this.i18n('Algo errado. Não foi possível autenticar')
          console.log("errorCallback", response);
        }
      }

      this.$http
        .post(this.$root.urls.sign_in, payload)
        .then(successCallback, errorCallback)
    },
    open2faDialogIfRequired() {
      if (this.$root.skip_2fa_for(this.email)) {
        const expire_at = new Date(new Date().getTime() + 60 * 12 * 60000) // 12 hours
        this.$cookies.set('has_2fa_enabled', true, expire_at)
        this.$cookies.set('2fa_authenticated', true, expire_at)
        this.$router.push('/dashboard')
      } else {
        const has_2fa_enabled = this.$cookies.get('has_2fa_enabled') === 'true'
        const is_2fa_authenticated = this.$cookies.get('2fa_authenticated') === 'true'
        if (has_2fa_enabled && !is_2fa_authenticated) {
          this.askCode = true
          this.$refs.loginDialog.onOpen()
        }
        if (!has_2fa_enabled) {
          this.askFor2fa = true
        }
        if (has_2fa_enabled && is_2fa_authenticated) {
          this.$router.push('/dashboard')
        }
      }
    },
    loadMe() {
      let successCallback = (response) => {
        if (response.body.company_id) {
          const expire_at = new Date(new Date().getTime() + 60 * 12 * 60000) // 12 hours
          this.$cookies.set("company_id", response.body.company_id, expire_at)
          this.$cookies.set("user_permissions", JSON.stringify(translateOldPermissions(response.body.permissions)), expire_at)
          const has_2fa_enabled = response.body.has_2fa_enabled
          this.$cookies.set("has_2fa_enabled", has_2fa_enabled, expire_at)
          this.$cookies.set("2fa_authenticated", false, expire_at)
          this.open2faDialogIfRequired()
        } else {
          this.$cookies.remove("company_id")
          this.$cookies.remove("user_permissions")
        }
      }

      let errorCallback = (response) => {
        this.$cookies.remove("company_id");
        console.log("errorCallback", response);
      };

      this.$root.store.company = false;

      let token = this.$cookies.get("api_token");
      this.$http
        .get(this.$root.urls.me, { headers: { Authorization: `Bearer ${token}` } })
        .then(successCallback, errorCallback);
    },
  },
  mounted() {
    this.toggleEnglish = (this.$cookies.get('lang') === 'en')
    const lastEmail = this.$cookies.get("last_email");
    if (lastEmail) {
      this.email = lastEmail;
      this.rememberMe = true;
    }
    let signed_in = this.$cookies.isKey("api_token") && this.$cookies.get("api_token") !== "";
    if (!signed_in) {
      this.$cookies.keys()
        .filter(cookie_key => 'lang' !== cookie_key)
        .forEach(cookie_key => this.$cookies.remove(cookie_key))
      this.$root.store.company = null;
    } else {
      this.open2faDialogIfRequired()
    }
  },
  metaInfo: {
    title: "Facilita Pay",
  },
};
</script>

<style scoped>
.login-page >>> .secondary-button-background-color--text{
  color: #27DABC !important;
}

.login-page .isActive {
  color: var(--primary-dark-font-color) !important;
  font-weight: normal;
}

.login-page span[style*="inline-flex"] {
  align-items: center !important;
  gap: 8px;
}

.login-page span.mr-2,
.login-page span.ml-2 {
  margin: 0 !important;
  padding: 0 !important;
  color: #B0BEC5;
  transition: color 0.2s;
}

.login-page .lang-toggle {
  margin: 0 4px !important;
  padding: 0 !important;
  align-self: center;
}

.login-page,
.login-page >>> .v-label,
.login-page >>> .v-input__slot input {
  color: var(--primary-dark-font-color) !important;
}

.login-page >>> .v-text-field .v-label {
  color: var(--secondary-dark-font-color) !important;
}

.login-page >>> .v-text-field .v-input__slot {
  border: 1px solid var(--secondary-dark-font-color) !important;
  border-radius: 4px;
}

.login-page >>> .v-input.error--text .v-input__slot,
.login-page >>> .v-text-field.error--text .v-input__slot {
  border-color: #FF5252 !important;
}

.login-page >>> .v-input--checkbox .v-icon {
  color: var(--secondary-button-background-color) !important;
}

.login-page >>> .v-input--switch__thumb {
  color: var(--secondary-button-background-color);
}

.login-page >>> .v-input--switch__track {
  color: var(--primary-button-background-color) !important;
}

.login-page >>> .v-input--switch .v-input--selection-controls__ripple {
  left: -14px;
  top: calc(50% - 24px);
  color: var(--secondary-button-background-color);
}

.login-page >>> .v-input--switch .v-input--selection-controls__input{
	width: 45px;
	margin-right: 10px;
  bottom: 10%;
}

.login-page >>> .v-input--switch__track{
	width: 40px;
	height: 26px;
	top: calc(50% - 13px);
	left: 0;
	right: 0;
	border-radius: 13px;
}

.sign-btn{
  padding: 30px;
  background-color: var(--secondary-button-background-color) !important;
}

.sign-btn:hover {
  opacity: 0.80;
}

.grey-text{
  color: #78909C;
}

.standard-text {
  color: var(--primary-dark-font-color) !important;
}

</style>



// WEBPACK FOOTER //
// src/Login.vue